import { Label } from "components/atoms";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  PiNotepad,
  PiSeal,
  PiSealCheck,
  PiSealQuestion,
  PiSealWarning,
} from 'react-icons/pi';
import { STATUS } from 'services/types';
import { IColorProp } from 'types/components/components.interface';
import LabeledStatementStatus from './LabeledStatementStatus';
import LabeledContractStatus from './LabeledContractStatus';
import LabeledActiveStatus from './LabeledActiveStatus';

export interface ILabeledStatusProps<T = STATUS> {
  status: T;
}

export interface ILabeledStatusParams<T = STATUS> extends IColorProp {
  status: T;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: STATUS.unknown,
    color: "gray",
    icon: <PiSealQuestion />,
  },
  {
    status: STATUS.draft,
    color: "black",
    icon: <PiNotepad />,
  },
  {
    status: STATUS.verified,
    color: "green",
    icon: <PiSealCheck />,
  },
  {
    status: STATUS.notVerified,
    color: "red",
    icon: <PiSealWarning />,
  },
  {
    status: STATUS.inVerification,
    color: "orange",
    icon: <PiSeal />,
  },
];

const LabeledStatus = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find((params) => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size="compact"
      color={labeledParams.color}
      title={t(`enum.STATUS.${STATUS[labeledParams.status]}`)}
    >
      {labeledParams.icon} {t(`enum.STATUS.${STATUS[labeledParams.status]}`)}
    </Label>
  );
};

LabeledStatus.Statement = LabeledStatementStatus;
LabeledStatus.Contract = LabeledContractStatus;
LabeledStatus.Active = LabeledActiveStatus;

export default LabeledStatus;
